import Icon1 from '../assets/coverage_icons/icon_cov_1.svg';
import Icon2 from '../assets/coverage_icons/icon_cov_2.svg';
import Icon3 from '../assets/coverage_icons/icon_cov_3.svg';
import Icon4 from '../assets/coverage_icons/icon_cov_4.svg';
import Icon5 from '../assets/coverage_icons/icon_cov_5.svg';
import Icon6 from '../assets/coverage_icons/icon_cov_6.svg';
import Icon7 from '../assets/coverage_icons/icon_cov_7.svg';

import ModalImg from '../assets/ModalImage.svg';
import Icon_standar_0 from '../assets/ic_sinister_0.svg';
import Icon_standar_1 from '../assets/ic_sinister_1.svg';
import Icon_standar_2 from '../assets/ic_sinister_2.svg';
import Icon_standar_3 from '../assets/ic_sinister_3.svg';
import Icon_standar_4 from '../assets/ic_sinister_4.svg';
import Icon_standar_5 from '../assets/ic_sinister_5.svg';
import Icon_standar_6 from '../assets/ic_sinister_6.svg';
import Icon_standar_7 from '../assets/ic_sinister_7.svg';

export const coveragesListTotal = [
  {
    code: 'COB01',
    sinisterNum: '1',
    icon: Icon1,
    title: 'Compras presenciales o realizadas por Internet no reconocidas',
    description: `
      A causa del robo, hurto, cambiazo de tu tarjeta crédito/débito BBVA o secuestro.
    `,
    innerModalInfo: `
      <p class='description'>
        Cuando se realizan <b>compras presenciales o por internet</b>, a causa
        del robo, hurto o cambiazo de tu tarjeta o en caso de secuestro.
      </p>
    `,
    modalInfo: `
      <div class='splitCont'>
        <ul class='splitList'>
          <li>Solo aplica para tarjetas de débito/crédito BBVA.</li>
          <li>Incluye compras por internet en páginas web extranjeras.</li>
          <li>
            Para compras presenciales solo aplican establecimientos a nivel
            nacional.
          </li>
        </ul>
        <ul class='splitList'>
          <li>Máximo 02 eventos al año.</li>
          <li>Cobertura máxima: Hasta S/ 5,000.</li>
        </ul>
      </div>
    `,
    amountInfo: 'Cobertura máxima: Hasta S/ 5,000.',
    warningTxt: `
      Solo aplica para tarjetas de crédito/débito BBVA. Compras presenciales solo en establecimientos a nivel nacional. Compras por internet en establecimientos nacionales y extranjeras.
    `,
    dollars: '',
    soles: '',
  },
  {
    code: 'COB02',
    sinisterNum: '2',
    icon: Icon2,
    title: 'Robo o hurto de dinero retirado en cajeros (ATM) del BBVA ',
    description: `
      Para retiros realizados de manera voluntaria o siendo forzado(a) por medio de un secuestro.
    `,
    innerModalInfo: `
      <p class='description'>
        Cuando te roban o hurtan el dinero retirado de un cajero (ATM) BBVA
        de manera voluntaria o siendo forzado(a) por medio de secuestro.
      </p>
    `,
    modalInfo: `
      <div class='splitCont'>
        <ul class='splitList'>
          <li>Solo aplica para tarjetas débito/crédito BBVA.</li>
          <li>Se considerarán todos los retiros que se hayan producido dentro de
            los 30 minutos siguientes de efectuado el primer retiro del cajero.
          </li>
        </ul>
        <ul class='splitList'>
          <li>Máximo 02 eventos al año.</li>
          <li>Cobertura máxima: Hasta S/ 2,000.</li>
        </ul>
      </div>
    `,
    amountInfo: 'Cobertura máxima: Hasta S/ 2,000.',
    warningTxt:
      'Solo aplica para tarjetas de crédito/débito BBVA y cajeros BBVA.',
    dollars: '',
    soles: '',
  },
  {
    code: 'COB03',
    sinisterNum: '3',
    icon: Icon3,
    title: 'Robo o hurto electrónico',
    description: `
      A causa de robo y/o hurto de contraseñas o información bancaria, incluyendo phishing y/o robo del celular.
    `,
    innerModalInfo: `
      <p class='description'>
        Cuando realizan compras, pagos o transferencias desde tus cuentas a
        causa del robo o hurto de tu información bancaria (a través de
        phishing) y/o móvil (celular).
      </p>
    `,
    modalInfo: `
      <div class='splitCont'>
        <ul class='splitList'>
          <li>Solo aplica para cuentas de débito/crédito BBVA.</li>
          <li>Máximo 01 evento al año.</li>
          <li>Cobertura máxima: Hasta S/4,000.</li>
        </ul>
        <ul class='splitList'>
          <li>App BBVA o Banca por internet.</li>
          <li>Contact center: (01)595 0000</li>
        </ul>
      </div>
    `,
    amountInfo: 'Cobertura máxima: Hasta S/ 4,000.',
    warningTxt: 'Solo aplica para cuentas asociadas a tarjetas BBVA.',
    dollars: '',
    soles: '',
  },
  {
    code: 'COB04',
    sinisterNum: '4',
    icon: Icon4,
    title:
      'Compras presenciales no reconocidas por el asegurado - Tarjetas de Otros Bancos',
    description: `
      A causa del robo o hurto de tus tarjetas de crédito de otros bancos.
    `,
    innerModalInfo: `
      <p class='description'> 
        Cuando realizan <span class="u-underline">compras presenciales </span>
        con tus tarjetas de crédito de otros bancos, a causa del robo o hurto
        de tus tarjetas.
      </p>
    `,
    modalInfo: `
      <div class='splitCont'>
        <ul class='splitList'>
          <li>Solo aplica para tarjetas de crédito de otros bancos.</li>
          <li>
            Para compras presenciales solo aplican establecimientos a nivel
            nacional.
          </li>
          <li>
            Solo es aplicable para el titular de la póliza (no adicionales).
          </li>
        </ul>
        <ul class='splitList'>
          <li>Máximo 02 eventos al año.</li>
          <li>Cobertura máxima: Hasta S/3,000.</li>
        </ul>
      </div>
    `,
    amountInfo: 'Cobertura máxima: Hasta S/ 3,000.',
    warningTxt:
      'Solo aplica para las tarjetas de otros bancos del titular de la póliza.',
    dollars: '',
    soles: '',
  },
  {
    code: 'OTRO_SINIESTRO',
    sinisterNum: '5',
    icon: Icon5,
    title: 'Mi siniestro es otro',
    description: `
      Si no encuentras un evento que se asemeje a lo que te sucedió.
    `,
    innerModalInfo: `
      <p class='description'>
        Si te ocurrió otro tipo de siniestro: No te preocupes, revisaremos tu caso
        y te indicaremos si se encuentra cubierto por tu seguro. Por favor
        continua completando el formulario.
      </p>
    `,
    modalInfo: `
    `,
    amountInfo: '',
    warningTxt: '',
    dollars: '',
    soles: '',
  },
];

export const coveragesListPremium = [
  {
    code: 'COB01',
    sinisterNum: '1',
    icon: Icon1,
    title: 'Compras presenciales o realizadas por Internet no reconocidas',
    description: `
      A causa del robo, hurto, cambiazo de tu tarjeta crédito/débito BBVA o secuestro.
    `,
    innerModalInfo: `
      <p class='description'>
        Cuando se realizan <b>compras presenciales o por internet</b>, a causa
        del robo, hurto o cambiazo de tu tarjeta o en caso de secuestro.
      </p>
    `,
    modalInfo: `
      <div class='splitCont'>
        <ul class='splitList'>
          <li>Solo aplica para tarjetas de débito/crédito BBVA.</li>
          <li>
            Para compras presenciales solo aplican establecimientos a nivel
            nacional.
          </li>
          <li>Incluye compras por internet en páginas web extranjeras.</li>
        </ul>
        <ul class='splitList'>
          <li>Máximo 02 eventos al año.</li>
          <li>Cobertura máxima: Hasta S/ 15,000.</li>
        </ul>
      <div/>
    `,
    amountInfo: 'Cobertura máxima: Hasta S/ 15,000.',
    warningTxt:
      'Solo aplica para tarjetas de crédito/débito BBVA. Compras presenciales solo en establecimientos a nivel nacional. Compras por internet en establecimientos nacionales y extranjeras.',
    dollars: '',
    soles: '',
  },
  {
    code: 'COB02',
    sinisterNum: '2',
    icon: Icon2,
    title: 'Robo o hurto de dinero retirado en cajeros (ATM) del BBVA ',
    description: `
      Para retiros realizados de manera voluntaria o siendo forzado(a) por medio de un secuestro.
    `,
    innerModalInfo: `
      <p class='description'>
        Cuando te roban o hurtan el dinero retirado de un acajero (ATM) BBVA
        de manera voluntaria o siendo forzado(a) por medio de secuestro.
      </p>
    `,
    modalInfo: `
      <div class='splitCont'>
        <ul class='splitList'>
          <li>Solo aplica para tarjetas débito/crédito BBVA.</li>
          <li>
            Se considerarán todos los retiros que se hayan producido dentro de
            los 30 minutos siguientes de efectuado el primer retiro del cajero.
          </li>
        </ul>
        <ul class='splitList'>
          <li>Máximo 02 eventos al año.</li>
          <li>Cobertura máxima: Hasta S/ 2,000.</li>
        </ul>
      </div>
    `,
    amountInfo: 'Cobertura máxima: Hasta S/ 2,000.',
    warningTxt:
      'Solo aplica para tarjetas de crédito/débito BBVA y cajeros BBVA.',
    dollars: '',
    soles: '',
  },
  {
    code: 'COB03',
    sinisterNum: '3',
    icon: Icon3,
    title: 'Robo o hurto electrónico',
    description: `
      A causa de robo y/o hurto de contraseñas o información bancaria, incluyendo phishing y/o robo del celular.
    `,
    innerModalInfo: `
      <p class='description'>
        Cuando realizan compras, pagos o transferencias desde tus cuentas a
        causa del robo o hurto de tu información bancaria (a través de
        phishing) y/o móvil (celular).
      </p>
    `,
    modalInfo: `
      <div>
        <div class='splitCont'>
          <ul class='splitList'>
            <li>Solo aplica para cuentas de débito/crédito BBVA.</li>
            <li>Máximo 01 evento al año.</li>
          </ul>
          <ul class='splitList'>
            <li>Cobertura máxima: Hasta S/7,000.</li>
          </ul>
        </div>
        <p>
          Para poder proceder con el análisis de tu siniestro deberás presentar
          la <b>carta emitida por el banco BBVA</b>. Ver ejemplo
          <a class="link" href="/assets/documents.v2/carta_de_respuesta_BBVA.png" target="_blank"
          rel="noopener noreferrer"> aquí</a>.<br />
          Solicítala a través de los siguientes canales:
        </p>
        <div class='splitCont'>
          <ul class='splitList'>
            <li>App BBVA o Banca por internet.</li>
          </ul>
          <ul class='splitList'>
            <li>Contact center: (01)595 0000</li>
          </ul>
        </div>
        <p class='grayCont'>
          <b>Exclusiones:</b> <br />
          Pérdidas derivadas de estafas y/o cualquier otro modo de engaño que no esté 
          específicamente señalado en la póliza. Para saber a detalle sobre phishing y 
          robo de celular, revisa el adjunto al correo que llegará al finalizar el formulario.
        </p>
      </div>
    `,
    amountInfo: 'Cobertura máxima: Hasta S/ 7,000.',
    warningTxt: 'Solo aplica para cuentas asociadas a tarjetas BBVA.',
    dollars: '',
    soles: '',
  },
  {
    code: 'COB04',
    sinisterNum: '4',
    icon: Icon4,
    title:
      'Compras presenciales no reconocidas por el asegurado - Tarjetas de Otros Bancos',
    description: `
      A causa del robo o hurto de tus tarjetas de crédito de otros bancos.
    `,
    innerModalInfo: `
      <p class='description'>
        Cuando realizan <span class="u-underline">compras presenciales </span>
        con tus tarjetas de crédito de otros bancos, a causa del robo o hurto
        de tus tarjetas.
      </p>
    `,
    modalInfo: `
      <div class='splitCont'>
        <ul class='splitList'>
          <li>Solo aplica para tarjetas de crédito de otros bancos.</li>
          <li>
            Para compras presenciales solo aplican establecimientos a nivel
            nacional.
          </li>
          <li>
            Solo es aplicable para el titular de la póliza (no adicionales).
          </li>
        </ul>
        <ul class='splitList'>
          <li>Máximo 02 eventos al año.</li>
          <li>Cobertura máxima: Hasta S/8,000.</li>
        </ul>
      </div>
    `,
    amountInfo: 'Cobertura máxima: Hasta S/ 8,000.',
    warningTxt:
      'Solo aplica para las tarjetas de otros bancos del titular de la póliza.',
    dollars: '',
    soles: '',
  },
  {
    code: 'COB05',
    sinisterNum: '6',
    icon: Icon6,
    title:
      'Operaciones no reconocidas por las Tarjetas de Crédito y/o Débito BBVA en el extranjero',
    description: `
      A consecuencia del robo y/o hurto de la(s) tarjeta(s) para operaciones no reconocidas que se realicen fuera del Perú.
    `,
    innerModalInfo: `
      <p class='description'>
        Compras presenciales y/o por internet, transferencias y retiros no
        reconocidos que se realicen fuera del Perú como consecuencia del robo
        o hurto de la tarjeta débito/crédito BBVA.
      </p>
    `,
    modalInfo: `
      <div>
        <ul class='fullList'>
          <li>Solo aplica para tarjetas débito/crédito BBVA.</li>
          <li>Máximo 01 evento al año.</li>
          <li>Cobertura máxima: Hasta S/ 3,000.</li>
        </ul>
      </div>
    `,
    amountInfo: 'Cobertura máxima: Hasta S/ 3,000.',
    warningTxt: 'Solo aplica para tarjetas de crédito/débito BBVA.',
    dollars: '',
    soles: '',
  },
  {
    code: 'COB06',
    sinisterNum: '7',
    icon: Icon7,
    title: 'Transferencias bancarias no reconocidas por el Asegurado',
    description: `
      A consecuencia de robo y/o hurto de la(s) tarjeta(s) débito BBVA.
    `,
    innerModalInfo: `
      <p class='description'>
        Cuando transfieren desde tus cuentas asociadas a tu tarjeta de débito
        BBVA a causa del robo o hurto de la misma.
      </p>
    `,
    modalInfo: `
      <div>
        <ul class='fullList'>
          <li>Solo aplica para tarjetas de débito BBVA.</li>
          <li>Máximo 01 evento al año.</li>
          <li>Cobertura máxima: Hasta S/ 3,000.</li>
        </ul>
        <p class='grayCont'>
          Exclusiones: 1. Solicitud de préstamos | 2. Compras y/o pagos a través
          del uso de cuentas CTS, Mancomunadas y Depósito a plazo fijo. | 3.
          Transferencias a través del uso de cuentas CTS, mancomunadas y
          Depósito a plazo fijo. | 4. Compras y/o pagos y/o transferencias
          realizadas con otros productos financieros distintos a la Tarjeta de
          Crédito y/o Débito del Titular.
        </p>
      </div>
    `,
    amountInfo: 'Cobertura máxima: Hasta S/ 3,000.',
    warningTxt: 'Solo para cuentas asociadas a tarjetas débito BBVA.',
    dollars: '',
    soles: '',
  },
  {
    code: 'OTRO_SINIESTRO',
    sinisterNum: '5',
    icon: Icon5,
    title: 'Mi siniestro es otro',
    description: `
      Si no encuentras un evento que se asemeje a lo que te sucedió.
    `,
    innerModalInfo: `
      <p class='description'>
        Si te ocurrió otro tipo de siniestro: </br>
        No te preocupes, revisaremos tu caso
        y te indicaremos si se encuentra cubierto por tu seguro. Por favor
        continúa completando el formulario.
      </p>
    `,
    modalInfo: `
    `,
    amountInfo: '',
    warningTxt: '',
    dollars: '',
    soles: '',
  },
];

export const coveragesListStandar = [
  {
    code: 'COB01',
    sinisterNum: '1',
    icon: Icon_standar_0,
    title: 'Compras vía internet NO reconocidas',
    description: `
      Realizaron compras vía internet con mi tarjeta de crédito y/o débito BBVA sin mi autorización y/o conocimiento.
    `,
    modalInfo: (
      <>
        <p>
          Cubre el monto que representen las compras fraudulentas con la tarjeta
          de crédito y/o débito BBVA sin la autorización y conocimiento del
          Titular, realizadas hasta 60 días antes de la fecha de bloqueo de la
          tarjeta involucrada.
        </p>
      </>
    ),
    amountInfo: 'Cobertura máxima para tarjetas BBVA: $10,000',
    warningTxt: '',
    dollars: '',
    soles: '',
    modalImg: ModalImg,
  },
  {
    code: 'COB01',
    sinisterNum: '2',
    icon: Icon_standar_1,
    title:
      'Uso indebido en establecimientos comerciales (compras presenciales)',
    description: `
      Usaron una o más de mis tarjetas en establecimiento comerciales luego de un robo o hurto. Aplica también para 
      tarjetas de crédito de otros bancos.
    `,
    modalInfo: (
      <>
        <p>
          <b>Aplica</b> si a consecuencia de un robo o hurto de la tarjeta
          asegurada, sea de crédito y/o débito, terceras personas hacen uso
          indebido de la misma únicamente en establecimientos comerciales de
          forma presencial.
        </p>
        <ul>
          <li>
            Te cubrimos hasta US$1,000 (Máx. 2 eventos anuales) solo para
            Tarjetas de crédito o débito BBVA.
          </li>{' '}
          <li>
            {' '}
            Te cubrimos hasta US$3,640 (Máx. 2 eventos anuales) solo para
            tarjetas de crédito de otros bancos.
          </li>
        </ul>
      </>
    ),
    amountInfo:
      'Cobertura máxima para tarjetas BBVA: $10,000\nCobertura máxima para tarjetas de otros bancos: $3,640',
    warningTxt:
      'Los montos robados se debieron haber realizado en establecimientos comerciales presenciales.',
    dollars: '',
    soles: '',
    modalImg: ModalImg,
  },
  {
    code: 'COB02',
    sinisterNum: '3',
    icon: Icon_standar_2,
    title: 'Robo de dinero retirado en cajeros BBVA',
    description: `
      Retiré dinero de un cajero BBVA y me robaron cerca al cajero (dentro de un radio de 200 mts).
    `,
    modalInfo: (
      <>
        <p>
          <b>Aplica</b> si te roban el dinero que has retirado voluntariamente
          de cajeros automáticos del BBVA :
        </p>{' '}
        <ul>
          {' '}
          <li>
            Te cubrimos hasta U$1,000 (Máx. 2 eventos anuales) solo para
            Tarjetas de crédito o débito BBVA.
          </li>{' '}
          <li>
            Cubre el robo de dinero dentro de un radio de 200 metros del cajero
            BBVA.
          </li>{' '}
        </ul>
      </>
    ),
    amountInfo:
      'Cobertura máxima para tarjetas BBVA: $1,000 (Entre “Robo de dinero retirado en cajeros BBVA” y “Uso forzado en cajeros BBVA”)',
    warningTxt:
      'Los montos robados debieron ser retirados con una tarjeta BBVA y un cajera BBVA.',
    dollars: '',
    soles: '',
    modalImg: ModalImg,
  },
  {
    code: 'COB03',
    sinisterNum: '4',
    icon: Icon_standar_3,
    title: 'Uso forzado en cajeros de BBVA',
    description: `
      Me obligaron a realizar operaciones de una o más de mis tarjetas BBVA en cajeros automáticos.
    `,
    modalInfo: (
      <>
        <p>
          <b>Aplica</b> si a consecuencia de un robo y/o secuestro te obligan a
          realizar una transacción por cajero automático:
        </p>{' '}
        <ul>
          {' '}
          <li>
            Te cubrimos hasta US$1,000 (Máx. 2 eventos anuales) solo para
            Tarjetas de crédito o débito BBVA.
          </li>{' '}
          <li>No aplica para agentes BBVA.</li>{' '}
        </ul>
      </>
    ),
    amountInfo:
      'Cobertura máxima para tarjetas BBVA: $1,000 (Entre “Robo de dinero retirado en cajeros BBVA” y “Uso forzado en cajeros BBVA”)',
    warningTxt:
      'Los montos robados son producto de operaciones realizadas con tarjetas BBVA.',
    dollars: '',
    soles: '',
    modalImg: ModalImg,
  },
  {
    code: 'COB04',
    sinisterNum: '5',
    icon: Icon_standar_4,
    title: 'Transferencias a cuenta de terceros',
    description: `
      Transfirieron desde una de mis cuentas a una cuenta de un tercero sin autorización mediante el uso de 
      claves y/o contraseñas.
    `,
    modalInfo: (
      <>
        <p>
          Se brinda cobertura respecto del dinero que se ha transferido desde tu
          cuenta corriente y/o ahorros sin autorización, mediante el uso
          indebido de tus claves y/o contraseñas, a consecuencia de robo y/o
          asalto.
        </p>{' '}
        <ul>
          {' '}
          <li>
            Te cubrimos hasta U$450 (Máx. 2 eventos anuales) solo para tarjetas
            de crédito o débito BBVA.
          </li>{' '}
          <li>Aplica para transferencias dentro o fuera del Perú.</li>{' '}
        </ul>
      </>
    ),
    amountInfo: 'Cobertura máxima: $450',
    warningTxt:
      'Las transferencias no reconocidas se debieron haber realizado a consecuencia de robo y/o asalto.',
    dollars: '',
    soles: '',
    modalImg: ModalImg,
  },
  {
    code: 'OTRO_SINIESTRO',
    sinisterNum: '8',
    icon: Icon_standar_7,
    title: 'Mi siniestro es otro',
    description: `
      Quiero reportar una situación diferente a las anteriores.
    `,
    modalInfo: `
      <p>
        No te preocupes, revisaremos tu caso y te indicaremos si se encuentra
        cubierto por tu seguro. Por favor continúa completando el formulario.
      </p>
      <p>
        <b>
          Si quieres reportar una muerte accidental, invalidez total o
          permanente:
        </b>
      </p>
      <p>
        Ingresa
        <a
          id="otro-siniestro"
          href="https://www.bbva.pe/content/dam/public-web/peru/documents/personas/seguros/Cobertura-de-MA-e-ITP.png"
          class="purple"
          target="_blank"
          rel="noopener noreferrer"
        >
          aquí
        </a>
        para ver los documentos solicitados. Para cualquier duda o consulta,
        comunicate al (1)595-9000 - Opción 3.
      </p>
    `,
    amountInfo: '',
    warningTxt: '',
    dollars: '',
    soles: '',
    modalImg: ModalImg,
  },
  {
    code: 'COB05',
    sinisterNum: '6',
    icon: Icon_standar_5,
    title: 'Reembolso por gastos de documentos',
    description: `
      He tenido que realizar gastos por duplicados (DNI, Pasaporte, Brevete, C.E) como consecuencia de robo
      y/o asalto y/o secuestro.
    `,
    modalInfo: (
      <>
        <p>
          Se brinda cobertura por los gastos del duplicado de documentos
          personales a causa de un robo y/o asalto y/o secuestro con la
          finalidad de sustraerle sus tarjetas de crédito y/o débito.
        </p>{' '}
        <ul>
          {' '}
          <li>
            Aplica solo para DNI, Brevete, Pasaporte y Carné de extranjería.
          </li>{' '}
          <li>
            Aplica para gastos de reposición de llaves y chapas (no incluye el
            costo de instalación).
          </li>{' '}
          <li>Te cubrimos hasta US$250 anuales (Máx. 2 eventos anuales).</li>{' '}
          <li>Aplica solo para casos en el Perú.</li>{' '}
          <li>
            No incluye gastos de movilidad y accesorios (billeteras, carteras,
            mochilas).
          </li>{' '}
        </ul>
      </>
    ),
    amountInfo: 'Cobertura máxima: $250',
    warningTxt:
      'Cubrimos los gastos del duplicado de documentos personales a causa de un robo y/o asalto y/o secuestro con la finalidad de sustraerle sus tarjetas de crédito y/o débito.',
    dollars: '',
    soles: '',
    modalImg: ModalImg,
  },
  {
    code: 'COB06',
    sinisterNum: '7',
    icon: Icon_standar_6,
    title: 'Reembolso por gastos de hospitalización',
    description: `
      Me hirieron y fui hospitalizado a cause de un robo y/o secuestro con la finalidad de apropiarse o usar
      indebidamente mis tarjetas.
    `,
    modalInfo: (
      <>
        <p>
          Se brinda cobertura por los gastos de hospitalización que se pudieran
          presentar a causa de robo y/o secuestro con la finalidad de apropiarse
          o realizar un uso indebido de las tarjetas de crédito y/o débito.
        </p>{' '}
        <ul>
          {' '}
          <li>
            Contempla gastos de tratamiento médico, medicinas y exámenes durante
            la hospitalización.
          </li>{' '}
          <li>Aplica solo para eventos ocurridos en el Perú.</li>{' '}
          <li>Te cubrimos hasta US$150 por día (Máx. 30 días).</li>{' '}
        </ul>
      </>
    ),
    amountInfo: 'Cobertura máxima: $150 por día, hasta 30 días',
    warningTxt:
      'Cubrimos gastos de hospitalización que se pudieran presentar a causa de robo y/o secuestro con la finalidad de apropiarse o realizar un uso indebido de las tarjetas de crédito y/o débito.',
    dollars: '',
    soles: '',
    modalImg: ModalImg,
  },
];